import { useRef, createRef, useState, useEffect } from 'react';
import { Container, Row, Col, Modal, Button } from 'react-bootstrap';
import { BannerUnSuperAlimento, NavegacionProductos } from '../../components';
import './styles.scss';
import { useLocation } from 'react-router';
import { ProductsLeaf } from '../../assets/images';
import RelatedRecipesCarousel from '../../components/RelatedRecipesCarousel'; 
import BotonBG from '../../assets/images/btn-comprar.png';

import logoAmazon from '../../assets/tiendas/amazon.png';
import logoWalmart from '../../assets/tiendas/walmart.png';
import logoWalmartExpress from '../../assets/tiendas/walmart_express.png';
import logoBodegaAurrera from '../../assets/tiendas/bodega_aurrera.png';
import logoSoriana from '../../assets/tiendas/soriana.png';
import logoChedraui from '../../assets/tiendas/chedraui.png';
import logoFresko from '../../assets/tiendas/fresko.png';
import logoCityMarket from '../../assets/tiendas/city_market.png';
import logoHEB from '../../assets/tiendas/heb.png';
import logoSams from '../../assets/tiendas/sams.png';
import logoCityClub from '../../assets/tiendas/city_club.png';
import logoCasaLey from '../../assets/tiendas/casa_ley.png';
import logoAlsuper from '../../assets/tiendas/alsuper.png';
import logoCalimax from '../../assets/tiendas/calimax.png';
import logoArteli from '../../assets/tiendas/arteli.png';
import logoFarmaciaGDL from '../../assets/tiendas/farmacia_gdl.png';
import logoMercadoLibre from '../../assets/tiendas/mercado_libre.png';
import logoJusto from '../../assets/tiendas/justo.png';
import { Helmet } from 'react-helmet';

const Productos = () => {
    const DOMElementRefs = useRef([...Array(2)].map(_ => createRef(null)));
    const [nutritionalTab, ingredientsTab] = DOMElementRefs.current;
    const imgUrl = process.env.REACT_APP_API_ENDPOINT_URI+'storage/';
    const { pathname } = useLocation();
    let [activetab, setActiveTab] = useState(true);
    let [product, setProduct] = useState([]);
    let [titleTop, setTitleTop] = useState('');
    let [titleBottom, setTitleBottom] = useState('');
    let [showModalCompra, setShowModalCompra] = useState(false);
    let [purchaseLinks, setPurchaseLinks] = useState([]);
    let [stores, setStores] = useState(null);

    useEffect(() => {
        const slug = pathname.substring(pathname.lastIndexOf('/') + 1);
        async function getProductsWithSlug() {
            const res = await fetch(
                process.env.REACT_APP_API_ENDPOINT_URI+'api/get_product/' +
                    slug,
                {
                    method: 'GET',
                }
            );
            const data = await res.json();
            if (data.product == null) {
                window.location.href = '/producto-no-existe';
            }
            setProduct((product = data.product));
            setPurchaseLinks(data.purchase_links);
            setStores(data.stores);
            setTitleTop(
                (titleTop = data.product.title.split(' ').slice(0, 2).join(' '))
            );
            setTitleBottom(
                (titleBottom = data.product.title
                    .split(' ')
                    .slice(2, 10)
                    .join(' '))
            );
        }
        async function getProducts() {
            const res = await fetch(
                process.env.REACT_APP_API_ENDPOINT_URI+'api/products',
                {
                    method: 'GET',
                }
            );
            const data = await res.json();
            setProduct((product = data.product));
            setPurchaseLinks(data.purchase_links); 
            setStores(data.stores);
            setTitleTop(
                (titleTop = data.product.title.split(' ').slice(0, 2).join(' '))
            );
            setTitleBottom(
                (titleBottom = data.product.title
                    .split(' ')
                    .slice(2, 10)
                    .join(' '))
            );
        }
        if (slug === 'productos') {
            getProducts();
        } else {
            getProductsWithSlug();
        }
    }, [pathname]); 

    
    const handleCompra = () => {
        setShowModalCompra(true);
    };

    const storeLabels = {
        amazon: 'Amazon',
        walmart: 'Walmart',
        walmart_express: 'Walmart Express',
        bodega_aurrera: 'Bodega Aurrerá',
        soriana: 'Soriana',
        chedraui: 'Chedraui',
        fresko: 'Fresko',
        city_market: 'City Market',
        heb: 'HEB',
        sams: 'SAMS',
        city_club: 'City Club',
        casa_ley: 'Casa Ley',
        alsuper: 'Alsuper',
        calimax: 'Calimax',
        arteli: 'arteli',
        smart: 'Smart',
        oxxo: 'Oxxo',
        farmacia_gdl: 'Farmacias Guadalajara',
        mercado_libre: 'Mercado Libre',
        justo: 'Justo',
        // etc, las que quieras mostrar
    };

    const storeLogos = {
        amazon: logoAmazon,
        walmart: logoWalmart,
        walmart_express: logoWalmartExpress,
        bodega_aurrera: logoBodegaAurrera,
        soriana: logoSoriana,
        chedraui: logoChedraui,
        fresko: logoFresko,
        city_market: logoCityMarket,
        heb: logoHEB,
        sams: logoSams,
        city_club: logoCityClub,
        casa_ley: logoCasaLey,
        alsuper: logoAlsuper,
        calimax: logoCalimax,
        arteli: logoArteli,
        farmacia_gdl: logoFarmaciaGDL,
        mercado_libre: logoMercadoLibre,
        justo: logoJusto
    };


    return (
        <>
            <Helmet>
                  <meta charSet='utf-8' />
                  <title>Productos Isadora | Frijoles y arroces listos para disfrutar</title>
                  <meta name="description" content="Explora los productos Isadora: frijoles refritos, frijoles enteros y arroces listos para disfrutar con el sabor de siempre." />
                  <link rel='canonical' href={window.location.href} />
                  <style type='text/css'>
                        {`
                            .sr-only {
                                position: absolute;
                                width: 1px;
                                height: 1px;
                                padding: 0;
                                margin: -1px;
                                overflow: hidden;
                                clip: rect(0, 0, 0, 0);
                                white-space: nowrap;
                                border-width: 0;
                            }
                        `}
                  </style>
            </Helmet>
            
            <NavegacionProductos />
            <section className='Product_section mx-auto'>
                <Container>
                    <Row>
                        <h1 className="sr-only">Productos</h1>
                        <Col className='prod_details_col'>
                            <img src={ProductsLeaf} alt='' />
                            <h2 className='title_top nickainleyReg'>
                                {titleTop}
                            </h2>
                            <h2 className='title_bottom'>{titleBottom}</h2>
                            <p className='robotoRegular'>{product.details}</p>
                            
                            <div className='btn-comprar' 
                                onClick={handleCompra} 
                                style={{ backgroundImage: `url(${BotonBG})` }}>
                                COMPRAR AHORA
                            </div>

                            <div
                                className='tab hk-grotesk'
                                ref={nutritionalTab}
                            >
                                {activetab ? (
                                    <div>
                                        <button
                                            className='tablinks  active_tab'
                                            onClick={() => setActiveTab(true)}
                                        >
                                            Declaración nutrimental
                                        </button>
                                        <button
                                            className='tablinks disactivated_Tab '
                                            onClick={() => setActiveTab(false)}
                                        >
                                            Ingredientes
                                        </button>
                                    </div>
                                ) : (
                                    <div>
                                        <button
                                            className='tablinks disactivated_Tab '
                                            onClick={() => setActiveTab(true)}
                                        >
                                            Declaración nutrimental
                                        </button>
                                        <button
                                            className='tablinks active_tab'
                                            onClick={() => setActiveTab(false)}
                                        >
                                            ingredientes
                                        </button>
                                    </div>
                                )}
                            </div>
                            {activetab ? (
                                <div
                                    className='tabcontent'
                                    ref={ingredientsTab}
                                >
                                    <img
                                        className='nutritional_img'
                                        src={
                                            imgUrl + product.nutricional_details
                                        }
                                        alt=''
                                    />
                                </div>
                            ) : (
                                <div className='tabcontent'>
                                    <p>{product.ingredients}</p>
                                </div>
                            )}

                            


                        </Col>
                        <Col className='prod_details_col order-first order-md-last'>
                            <div
                                className='img_container'
                                style={{
                                    backgroundImage:
                                        "url('" +
                                        imgUrl +
                                        product.backside_imagen +
                                        "')",
                                }}
                            >
                                <img
                                    src={imgUrl + product.active_image}
                                    alt=''
                                />
                                <p>
                                    Pasa el puntero sobre la imagen para ver el
                                    reverso.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <RelatedRecipesCarousel />
            <BannerUnSuperAlimento />

            <Modal
                show={showModalCompra}
                onHide={() => setShowModalCompra(false)}
                centered 
                dialogClassName="modal-compra-dialog"
                contentClassName="modal-compra-content"
                className="modal-compra-body"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Selecciona tu tienda favorita y compra online</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {stores ? (
                        <div className="store-logos-container">
                            {Object.entries(storeLabels).map(([key, label]) => {
                                // stores[key] será la URL, por ejemplo stores.amazon
                                const url = stores[key];

                                // Si viene vacío, null, undefined, no lo mostramos
                                if (!url || url.trim() === '') {
                                    return null;
                                }

                                return (
                                   
                                        <a key={key}
                                            href={url}
                                            target="_blank"
                                            rel="noreferrer" 
                                            className="store-logo-link"
                                        >
                                        <img src={storeLogos[key]} alt={label} className="store-logo" />
                                           
                                        </a>
                                    
                                );
                            })}
                        </div>
                    ) : (
                        <p>No hay enlaces de compra disponibles para este producto.</p>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalCompra(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>









        </>
    );
};

export default Productos;
